export const countryCodes = [
    { code: "+1", label: "Canada +1" },
    { code: "+93", label: "Afghanistan +93" },
    { code: "+355", label: "Albania +355" },
    { code: "+213", label: "Algeria +213" },
    { code: "+376", label: "Andorra +376" },
    { code: "+244", label: "Angola +244" },
    { code: "+54", label: "Argentina +54" },
    { code: "+374", label: "Armenia +374" },
    { code: "+61", label: "Australia +61" },
    { code: "+43", label: "Austria +43" },
    { code: "+994", label: "Azerbaijan +994" },
    { code: "+973", label: "Bahrain +973" },
    { code: "+880", label: "Bangladesh +880" },
    { code: "+375", label: "Belarus +375" },
    { code: "+32", label: "Belgium +32" },
    { code: "+501", label: "Belize +501" },
    { code: "+229", label: "Benin +229" },
    { code: "+975", label: "Bhutan +975" },
    { code: "+591", label: "Bolivia +591" },
    { code: "+387", label: "Bosnia and Herzegovina +387" },
    { code: "+267", label: "Botswana +267" },
    { code: "+55", label: "Brazil +55" },
    { code: "+673", label: "Brunei +673" },
    { code: "+359", label: "Bulgaria +359" },
    { code: "+226", label: "Burkina Faso +226" },
    { code: "+257", label: "Burundi +257" },
    { code: "+855", label: "Cambodia +855" },
    { code: "+237", label: "Cameroon +237" },

    { code: "+238", label: "Cape Verde +238" },
    { code: "+236", label: "Central African Republic +236" },
    { code: "+235", label: "Chad +235" },
    { code: "+56", label: "Chile +56" },
    { code: "+86", label: "China +86" },
    { code: "+57", label: "Colombia +57" },
    { code: "+269", label: "Comoros +269" },
    { code: "+506", label: "Costa Rica +506" },
    { code: "+385", label: "Croatia +385" },
    { code: "+53", label: "Cuba +53" },
    { code: "+357", label: "Cyprus +357" },
    { code: "+420", label: "Czech Republic +420" },
    { code: "+45", label: "Denmark +45" },
    { code: "+253", label: "Djibouti +253" },
    { code: "+593", label: "Ecuador +593" },
    { code: "+20", label: "Egypt +20" },
    { code: "+503", label: "El Salvador +503" },
    { code: "+240", label: "Equatorial Guinea +240" },
    { code: "+291", label: "Eritrea +291" },
    { code: "+372", label: "Estonia +372" },
    { code: "+251", label: "Ethiopia +251" },
    { code: "+679", label: "Fiji +679" },
    { code: "+358", label: "Finland +358" },
    { code: "+33", label: "France +33" },
    { code: "+241", label: "Gabon +241" },
    { code: "+220", label: "Gambia +220" },
    { code: "+995", label: "Georgia +995" },
    { code: "+49", label: "Germany +49" },
    { code: "+233", label: "Ghana +233" },
    { code: "+30", label: "Greece +30" },
    { code: "+299", label: "Greenland +299" },
    { code: "+502", label: "Guatemala +502" },
    { code: "+224", label: "Guinea +224" },
    { code: "+592", label: "Guyana +592" },
    { code: "+509", label: "Haiti +509" },
    { code: "+504", label: "Honduras +504" },
    { code: "+36", label: "Hungary +36" },
    { code: "+354", label: "Iceland +354" },
    { code: "+91", label: "India +91" },
    { code: "+62", label: "Indonesia +62" },
    { code: "+98", label: "Iran +98" },
    { code: "+964", label: "Iraq +964" },
    { code: "+353", label: "Ireland +353" },
    { code: "+972", label: "Israel +972" },
    { code: "+39", label: "Italy +39" },
    { code: "+225", label: "Ivory Coast +225" },
    { code: "+81", label: "Japan +81" },
    { code: "+962", label: "Jordan +962" },
    { code: "+7", label: "Kazakhstan +7" },
    { code: "+254", label: "Kenya +254" },
    { code: "+82", label: "South Korea +82" },
    { code: "+965", label: "Kuwait +965" },
    { code: "+996", label: "Kyrgyzstan +996" },
    { code: "+856", label: "Laos +856" },
    { code: "+371", label: "Latvia +371" },
    { code: "+961", label: "Lebanon +961" },
    { code: "+266", label: "Lesotho +266" },
    { code: "+231", label: "Liberia +231" },
    { code: "+218", label: "Libya +218" },
    { code: "+423", label: "Liechtenstein +423" },
    { code: "+370", label: "Lithuania +370" },
    { code: "+352", label: "Luxembourg +352" },
    { code: "+389", label: "North Macedonia +389" },
    { code: "+261", label: "Madagascar +261" },
    { code: "+265", label: "Malawi +265" },
    { code: "+60", label: "Malaysia +60" },
    { code: "+960", label: "Maldives +960" },
    { code: "+223", label: "Mali +223" },
    { code: "+356", label: "Malta +356" },
    { code: "+52", label: "Mexico +52" },
    { code: "+373", label: "Moldova +373" },
    { code: "+377", label: "Monaco +377" },
    { code: "+976", label: "Mongolia +976" },
    { code: "+382", label: "Montenegro +382" },
    { code: "+212", label: "Morocco +212" },
    { code: "+258", label: "Mozambique +258" },
    { code: "+95", label: "Myanmar +95" },
    { code: "+264", label: "Namibia +264" },
    { code: "+977", label: "Nepal +977" },
    { code: "+31", label: "Netherlands +31" },
    { code: "+64", label: "New Zealand +64" },
    { code: "+505", label: "Nicaragua +505" },
    { code: "+227", label: "Niger +227" },
    { code: "+234", label: "Nigeria +234" },
    { code: "+47", label: "Norway +47" },
    { code: "+968", label: "Oman +968" },
    { code: "+92", label: "Pakistan +92" },
    { code: "+507", label: "Panama +507" },
    { code: "+675", label: "Papua New Guinea +675" },
    { code: "+595", label: "Paraguay +595" },
    { code: "+51", label: "Peru +51" },
    { code: "+63", label: "Philippines +63" },
    { code: "+48", label: "Poland +48" },
    { code: "+351", label: "Portugal +351" },
    { code: "+974", label: "Qatar +974" },
    { code: "+40", label: "Romania +40" },
    { code: "+7", label: "Russia +7" },
    { code: "+250", label: "Rwanda +250" },
    { code: "+966", label: "Saudi Arabia +966" },
    { code: "+221", label: "Senegal +221" },
    { code: "+381", label: "Serbia +381" },
    { code: "+65", label: "Singapore +65" },
    { code: "+421", label: "Slovakia +421" },
    { code: "+386", label: "Slovenia +386" },
    { code: "+27", label: "South Africa +27" },
    { code: "+34", label: "Spain +34" },
    { code: "+94", label: "Sri Lanka +94" },
    { code: "+249", label: "Sudan +249" },
    { code: "+46", label: "Sweden +46" },
    { code: "+41", label: "Switzerland +41" },
    { code: "+963", label: "Syria +963" },
    { code: "+886", label: "Taiwan +886" },
    { code: "+992", label: "Tajikistan +992" },
    { code: "+255", label: "Tanzania +255" },
    { code: "+66", label: "Thailand +66" },
    { code: "+228", label: "Togo +228" },
    { code: "+676", label: "Tonga +676" },
    { code: "+216", label: "Tunisia +216" },
    { code: "+90", label: "Turkey +90" },
    { code: "+993", label: "Turkmenistan +993" },
    { code: "+256", label: "Uganda +256" },
    { code: "+380", label: "Ukraine +380" },
    { code: "+971", label: "United Arab Emirates +971" },
    { code: "+44", label: "United Kingdom +44" },
    { code: "+1", label: "United States +1" },
    { code: "+598", label: "Uruguay +598" },
    { code: "+998", label: "Uzbekistan +998" },
    { code: "+58", label: "Venezuela +58" },
    { code: "+84", label: "Vietnam +84" },
    { code: "+967", label: "Yemen +967" },
    { code: "+260", label: "Zambia +260" },
    { code: "+263", label: "Zimbabwe +263" },
];